"use strict";

module.exports = /*@ngInject*/function ($resource, $q, $window, ConfigService, LokiService, ChecklistService, PreferenceService) {
  var _ConfigService$getCon = ConfigService.getConfig(),
    INSPECT_URL = _ConfigService$getCon.INSPECT_URL;
  var service = $resource("".concat(INSPECT_URL, "/api/program/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/program/:id")
    },
    upsertMember: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/program/:id/member/:memberId")
    },
    removeMember: {
      method: 'DELETE',
      url: "".concat(INSPECT_URL, "/api/program/:id/member/:memberId")
    },
    findByRole: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/program/member/role/:role"),
      isArray: true
    },
    getParties: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/program/:id/parties"),
      isArray: true
    },
    _sync: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/program/sync")
    },
    findAllConfigurations: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/program/configuration/find/all"),
      isArray: true
    },
    getConfigurationDetail: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/program/configuration/:id/detail")
    },
    createConfiguration: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/program/:id/configuration/")
    },
    updateConfiguration: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/program/:id/configuration/:configurationId")
    },
    deleteConfiguration: {
      method: 'DELETE',
      url: "".concat(INSPECT_URL, "/api/program/:id/configuration/:configurationId")
    },
    findProgramByIntegratedWithApp: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/program/campus/:campusCode/integrated-with/:appName"),
      cache: true
    }
  });
  service.getAllConfigurations = function (options, cb) {
    return LokiService.collection('configuration').then(function (collection) {
      return cb ? cb(collection.data) : collection.data;
    });
  };
  service.sync = function (options, cb) {
    if (options.forceSync) {
      PreferenceService.save('lastSynced', null);
    }
    var preference = PreferenceService.get();
    var post = {
      lastSynced: preference.lastSynced || null
    };
    service._sync({}, post, function (data) {
      PreferenceService.save('lastSynced', Date.now());
      LokiService.upsertAllCollection(data, options, cb);
    });
  };
  return service;
};